import { render, staticRenderFns } from "./Compras.vue?vue&type=template&id=15c14956&scoped=true&"
import script from "./Compras.vue?vue&type=script&lang=js&"
export * from "./Compras.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Compras.vue?vue&type=style&index=1&id=15c14956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c14956",
  null
  
)

export default component.exports